import { DynamicFieldData } from '@/shared/components/DynamicForm/models/DynamicFieldData'
import { DynamicFormDefinition } from '@/shared/components/DynamicForm/models/DynamicFormSection'
import { DEFAULT_MAP_CENTER_LAT, DEFAULT_MAP_CENTER_LON, DEFAULT_MAP_ZOOM } from '@/shared/config/consts'
import { FormFieldDefaultValue, FormFieldSelectOptions, getDynamicFormFields } from '@/shared/lib/getDynamicFormFields'

const defaultGroupDetailFields: DynamicFieldData[] = [
  {
    fieldType: 'text',
    fieldName: 'name',
    label: 'Group Name',
    placeholder: 'Enter Group Name',
    defaultValue: '',
    required: true,
    config: {
      required: 'This field is required',
    },
  },
  {
    fieldType: 'select',
    fieldName: 'timeZone',
    label: 'Time Zone',
    defaultValue: undefined,
    placeholder: 'Select Time Zone',
    required: true,
    options: [],
    config: {
      required: 'This field is required',
    },
  },
  {
    fieldType: 'checkbox',
    fieldName: 'orderHasLineItem',
    label: 'Order Line Items',
    defaultValue: false,
    labelPlacement: 'end',
  },
  {
    fieldType: 'section',
    fieldName: 'mapSection',
    label: 'Default Map Center',
    showDivider: true,
  },
  {
    fieldType: 'map',
    fieldName: 'mapCenter',
    label: 'Map Center',
    defaultValue: {
      latitude: DEFAULT_MAP_CENTER_LAT,
      longitude: DEFAULT_MAP_CENTER_LON,
      zoomLevel: DEFAULT_MAP_ZOOM,
    },
  },
]

export const initialGroupFormValues = {
  name: '',
  orderHasLineItem: false,
  isActive: true,
  timeZone: undefined,
  mapCenter: {
    latitude: DEFAULT_MAP_CENTER_LAT,
    longitude: DEFAULT_MAP_CENTER_LON,
    zoomLevel: DEFAULT_MAP_ZOOM,
  },
}

type GetGroupFormDefinitionArgs = {
  defaultValues?: FormFieldDefaultValue
  selectOptions?: FormFieldSelectOptions
}

export const getGroupFormDefinition = ({
  defaultValues,
  selectOptions,
}: GetGroupFormDefinitionArgs): DynamicFormDefinition => {
  // Update select options with provided data
  const fields = getDynamicFormFields({
    fields: defaultGroupDetailFields,
    defaultValues,
    selectOptions,
  })

  const formDefinition: DynamicFormDefinition = {
    formType: 'default',
    sections: [
      {
        label: 'Group Details',
        fields,
      },
    ],
  }

  return formDefinition
}